import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";

const LinkToRender = ({ customUrl, linkTo, children }) =>
  !!customUrl ? (
    <a
      href={customUrl}
      className="navigation-link"
      data-testid="external-anchor"
    >
      {children}
    </a>
  ) : (
    <NavLink
      to={linkTo}
      className="navigation-link"
      data-testid="internal-anchor"
    >
      {children}
    </NavLink>
  );

export const CardBrand = ({
  image,
  brandName,
  info = null,
  linkTo,
  customUrl = null,
  customClassName = ""
}) => (
  <LinkToRender customUrl={customUrl} linkTo={linkTo}>
    <div className={`card-brand ${customClassName}`}>
      <div className="image-container">
        <img
          src={image}
          alt={`${brandName} brand`}
          key={image}
          height={100}
          width={100}
          loading="lazy"
        />
      </div>
      <div className="container-brand-name">
        <span className="brand-name">{brandName} Gift Cards</span>
        {info && <span className="discount">{info}</span>}
      </div>
    </div>
  </LinkToRender>
);
